import { Checkbox } from 'semantic-ui-react';
import {
    useAllPossibleImportCandidateColumnsSelected,
    useMetadataStoreActions,
} from '../../../../../../stores/metadataStore';
import { TableIdType } from '../../../../../../types';

type ColumnInclusionTogglePropsType = {
    tableId: TableIdType;
};

const ColumnInclusionToggle = ({ tableId }: ColumnInclusionTogglePropsType) => {
    const { toggleTableColsImportCandidateStatus } = useMetadataStoreActions();
    const value = useAllPossibleImportCandidateColumnsSelected(tableId);

    return (
        <Checkbox
            checked={value}
            onChange={() => toggleTableColsImportCandidateStatus(tableId)}
        />
    );
};

export default ColumnInclusionToggle;
